<template>
  <div class="form-container">
    <h1 class="mb-4">建物種別情報編集</h1>
    <form @submit.prevent="handleSubmit" @keydown.enter.prevent>

      <div class="mb-3">
        <label for="building_typeName" class="form-label">建物種別名 <span class="badge text-bg-danger">必須</span></label>
        <input v-model="building_type.building_type_nm" type="text" placeholder="建物種別名" class="form-control" id="building_typeName" required>
        <div v-if="errorMessages.building_type_nm" class="alert alert-danger mt-2">{{ errorMessages.building_type_nm[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="corpNum" class="form-label">並び順 <span class="badge text-bg-danger">必須</span></label>
        <input v-model="building_type.sort_no" type="text" placeholder="並び順" class="form-control" id="sortNo" required>
        <div v-if="errorMessages.sort_no" class="alert alert-danger mt-2">{{ errorMessages.sort_no[0] }}</div>
      </div>

      <div class="btn-area">
        <a class="btn btn-secondary mx-1" @click="$router.back()">戻る</a>
        <button type="submit" class="btn btn-success mx-1">更新</button>
      </div>
    </form>
  </div>
</template>

<script>
import { ref, onMounted, watchEffect } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { getBuildingType, updateBuildingType } from '@/api/axios';

export default {
  setup() {
    const title = ref('建物種別情報編集');

    watchEffect(() => {
      document.title = title.value;
    });

    const building_type = ref({
      building_type_nm: '',
      sort_no: ''
      // 他のフィールド
    });

    // エラーメッセージ用のリアクティブプロパティ
    const errorMessages = ref({});

    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const buildingTypeId = route.params.id; // URLから建物種別情報IDを取得

    const loadBuildingTypeData = async () => {
      try {
        const response = await getBuildingType(buildingTypeId, { include_visibility_hidden: true });
        building_type.value = response.data;
      } catch (error) {
        console.error('建物種別情報データの取得に失敗しました:', error);
      }
    };

    const handleSubmit = async () => {
      try {
        await updateBuildingType(buildingTypeId, building_type.value, { include_visibility_hidden: true });
        store.commit('setFlashMessage', {message: '建物種別情報更新完了！', type: 'success'});
        router.push(`/building-types/${buildingTypeId}`);
      } catch (error) {
        if (error.response && error.response.data) {
          // エラーメッセージをerrorMessagesにセット
          errorMessages.value = error.response.data || {};
        }
        store.commit('setFlashMessage', {message: '建物種別情報更新失敗！', type: 'danger'});
        console.error('更新エラー:', error);
      }
    };

    onMounted(loadBuildingTypeData);

    return {
      title,
      building_type,
      handleSubmit,
      errorMessages
    };
  }
};
</script>

<style scoped>
.form-container {
  padding: 20px;
  width: 70%;
  margin: auto;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

input[type="text"],
input[type="email"],
input[type="password"] {
  width: 100%;
  padding: 10px;
  margin-bottom: 4px;
  border: 1px solid #ddd;
  border-radius: 5px;
}

.btn-area{
  text-align: center;
}
</style>
